"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Cum pot face o programare la service?",
  answer: "Puteți face o programare rapid prin telefon la 0745 236 441, prin WhatsApp sau direct la sediul nostru din Brașov. Recomandăm programarea în avans pentru a asigura disponibilitatea."
}, {
  question: "Oferiți servicii de transport pentru motociclete?",
  answer: "Da, oferim transport la domiciliu pentru motocicletele care nu se pot deplasa sau pentru clienții care doresc preluarea și livrarea moto de la locația lor."
}, {
  question: "Ce mărci de motociclete reparați?",
  answer: "Echipa noastră are experiență cu toate mărcile majore, inclusiv Honda, Yamaha, BMW, Kawasaki, Suzuki, Ducati și KTM, folosind piese de origine sau after-market de calitate."
}, {
  question: "Cât durează o revizie periodică obișnuită?",
  answer: "O revizie standard (schimb ulei, filtre, verificare generală) durează de obicei între 2 și 4 ore, în funcție de complexitatea modelului și de volumul de muncă din atelier."
}, {
  question: "Pot lăsa motocicleta la voi pe timpul iernii?",
  answer: "Absolut. Oferim serviciul de Hotel Moto (depozitare iarnă) în condiții optime de temperatură și umiditate, incluzând întreținerea bateriei și verificarea fluidelor."
}, {
  question: "Acceptați plata cu cardul sau doar numerar?",
  answer: "Acceptăm atât plata numerar, cât și plata prin card bancar sau transfer bancar, oferind factură și garanție pentru toate lucrările efectuate în service-ul nostru."
}];
export default function InsideTheAcademy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222772" id="întrebări-frecvente" className="bg-white text-foreground relative overflow-hidden pt-16 pb-24 lg:pt-24 lg:pb-32 border-t border-border">
      <div ref={ref} className={`relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-20 max-w-2xl">
          <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-foreground ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
            Întrebări Frecvente
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-xl leading-relaxed">
            Tot ce trebuie să știi despre serviciile Pure Moto Performance și
            procesul de programare.
          </p>
        </div>

        <Accordion type="single" collapsible className="flex max-w-4xl flex-col gap-6">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group/item border-none bg-white shadow-md rounded-xl ring-1 ring-border transition-all duration-500 data-[state=open]:bg-white data-[state=open]:ring-primary/30 data-[state=open]:shadow-xl">
              <AccordionTrigger className="group/trigger [&>svg]:hidden hover:no-underline p-0">
                <div className="flex w-full items-center justify-between p-6 sm:p-8 gap-4">
                  <h3 className="font-default text-xl font-bold text-left text-primary transition-colors group-hover/trigger:text-primary">
                    {faq.question}
                  </h3>

                  {}
                  <div className="relative flex size-10 shrink-0 items-center justify-center rounded-md bg-muted border border-border transition-transform duration-500 ease-in-out group-data-[state=open]/trigger:bg-primary group-data-[state=open]/trigger:border-primary">
                    {}
                    <span className="absolute h-[2px] w-4 rounded-full bg-secondary transition-transform duration-500 ease-in-out group-data-[state=open]/trigger:rotate-180 group-data-[state=open]/trigger:bg-white" />
                    {}
                    <span className="absolute h-4 w-[2px] rounded-full bg-secondary transition-all duration-500 ease-in-out group-data-[state=open]/trigger:rotate-90 group-data-[state=open]/trigger:opacity-0" />
                  </div>
                </div>
              </AccordionTrigger>

              <AccordionContent className="px-6 pb-6 sm:px-8 sm:pb-8 pt-0">
                <p className="text-base text-muted-foreground font-default leading-relaxed max-w-3xl">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}